import type { VarianteChip } from '../ui';
import type { LogGeralItem, TipoDeAtor } from '../api/log-geral/logGeralApi';

/**
 * Regras de apresentação do log geral (at-85). Funções puras, fora do componente
 * (convenção at-24): a lista e o detalhe precisam dizer a mesma coisa sobre a mesma linha.
 */

export const ROTULO_TIPO_DE_ATOR: Record<TipoDeAtor, string> = {
  USUARIO: 'Usuário',
  PUBLICO: 'Público (sem login)',
  INTEGRACAO: 'Integração',
  SISTEMA: 'Sistema',
};

const ROTULO_PAPEL: Record<string, string> = {
  CONSULTOR: 'Consultor',
  TI: 'TI',
  ADMIN: 'Administrador',
};

/** "Victor · TI", ou o tipo de ator quando não há pessoa (rotina, integração). */
export function descreverQuem(l: Pick<LogGeralItem, 'quem' | 'atorPapel' | 'atorTipo'>): string {
  const papel = l.atorPapel ? ROTULO_PAPEL[l.atorPapel] ?? l.atorPapel : null;
  return papel ? `${l.quem} · ${papel}` : l.quem;
}

/**
 * ⚠️ Falha é `perigo` (vermelho), e aqui está certo: diferente de "pendente de envio", uma
 * linha do log que falhou é um desfecho que não vai se resolver sozinho — é o fato registrado.
 */
export function rotuloResultado(l: Pick<LogGeralItem, 'sucesso' | 'statusCode'>): { texto: string; variante: VarianteChip } {
  if (l.sucesso) return { texto: 'Sucesso', variante: 'ok' };
  return { texto: l.statusCode ? `Falha (${l.statusCode})` : 'Falha', variante: 'perigo' };
}

/**
 * Origem: a rota da requisição, ou — para o que não veio de HTTP — "Rotina automática" /
 * "Registro interno". Nunca um traço mudo: sem rota não é dado faltando, é outro caminho.
 */
export function descreverOrigem(l: Pick<LogGeralItem, 'rota' | 'metodo' | 'atorTipo' | 'tipo'>): string {
  if (l.rota) return `${l.metodo ?? ''} ${l.rota}`.trim();
  if (l.atorTipo === 'SISTEMA') return 'Rotina automática';
  return 'Registro interno';
}

/** Valor do "antes e depois" em texto: nulo vira "vazio", objeto vira JSON curto. */
export function textoDoValor(v: unknown): string {
  if (v === null || v === undefined || v === '') return 'vazio';
  if (typeof v === 'boolean') return v ? 'Sim' : 'Não';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}
